export const BankCodes = {
    VENEZUELA: '0102',
    VENEZOLANO_CREDITO: '0104',
    MERCANTIL: '0105',
    PROVINCIAL: '0108',
    BANCARIBE: '0114',
    EXTERIOR: '0115',
    BOD: '0116',
    CARONI: '0128',
    BANESCO: '0134',
    SOFITASA: '0137',
    PLAZA: '0138',
    BANGENTE: '0146',
    PUEBLO_SOBERANO: '0149',
    FONDO_COMUN: '0151',
    CIEN_PORCIENTO: '0158',
    DEL_SUR: '0157',
    TESORO: '0163',
    AGRICOLA: '0166',
    BANCRECER: '0168',
    MI_BANCO: '0169',
    ACTIVO: '0171',
    BANCAMIGA: '0172',
    INTERCONTINENTAL_DESARROLLO: '0173',
    BANPLUS: '0174',
    BICENTENARIO: '0176',
    BANFANB: '0177',
    BNC: '0191'
}

export const PaymentStatus = {
    Error: 'Error',
    Success: 'Confirmado'
}

export const PAYMENT_FORM = 'PAYMENT_FORM'
export const CLEAR_FORM = 'CLEAR_FORM'
export const BANK_DATA = 'BANK_DATA'
export const USER_FORM = 'USER_FORM'
